import { Modal, ScrollArea } from '@mantine/core';
import { useClientTerminology } from '@/views/list/NetworkTerms';

import classes from '@/views/list/GroupItem.module.css';
import { useDisclosure } from '@mantine/hooks';
import { CustomListBulkSelector } from './CustomListBulkSelector';
import { CustomListIndividualSelector } from './CustomListIndividualSelector';
import TagManager from 'react-gtm-module';
import { GoogleEvents } from '@/features/googleEvents';

type ModalOptions =
  | {
      mode: 'individual';
      level2: string;
      level3: string;
    }
  | {
      mode?: 'bulk';
    };

export function useCustomListSelectorModal(
  options: ModalOptions = { mode: 'bulk' }
) {
  const intl = useClientTerminology();
  const [modalIsOpen, { close: closeModal, open: openModal }] =
    useDisclosure(false);

  const modalComponent = (
    <Modal
      title={intl.formatMessage({
        id: 'customList.addToList',
      })}
      scrollAreaComponent={ScrollArea.Autosize} // We use this component because it works better with the modal border radius
      classNames={{
        header: classes.addToListModalHeader,
        close: classes.addToListModalClose,
      }}
      radius="lg"
      opened={modalIsOpen}
      onClose={() => {
        TagManager.dataLayer({
          dataLayer: {
            event: GoogleEvents.projects.clickOut.addToProject, // clicked on close button in modal
          },
        });
        closeModal();
      }}
      size="xl"
    >
      {options.mode === 'individual' ? (
        <CustomListIndividualSelector
          onCloseHandler={closeModal}
          level2={options.level2}
          level3={options.level3}
        />
      ) : (
        <CustomListBulkSelector onCloseHandler={closeModal} />
      )}
    </Modal>
  );

  return {
    modalIsOpen,
    openModal,
    closeModal,
    modalComponent,
  };
}
